import { storeProductQueryPosition } from './storeProductQueryPosition'

export const algolia = { storeProductQueryPosition }
